import { PathOptions } from "leaflet";

export const areas_suscetiveis_desertificacao = (
  feature: any
): PathOptions => {
  const classe = feature.properties?.classe;

  // Áreas Semiáridas - Semi-arid areas
  if (classe === "Áreas Semiáridas") {
    return {
      fillColor: "#dd8f0f",
      color: "#232323",
      weight: 1,
      opacity: 0, // Invisible border
      fillOpacity: 0.7,
    };
  }

  // Áreas Subúmidas - Sub-humid areas
  if (classe === "Áreas Subúmidas") {
    return {
      fillColor: "#f9c161",
      color: "#f5b54e",
      weight: 1,
      opacity: 0, // Invisible border
      fillOpacity: 0.7,
    };
  }

  // Default fallback (shouldn't happen if data is complete)
  return {
    fillColor: "#d4a373",
    color: "#8b6f47",
    weight: 1,
    opacity: 0.5,
    fillOpacity: 0.4,
  };
};
